import React from "react";
import { TicketData } from "../..";

export const TicketContext = React.createContext<TicketData>(undefined);
export const TicketContextProvider = TicketContext.Provider;
